var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cms-html-block" }, [
    _vm.hasErrors
      ? _c("div", { staticClass: "cms-html-block__error-bar" }, [
          _c("i", { staticClass: "fa fa-exclamation-triangle" }),
          _vm._v(
            "\n\t\tBroken HTML — " +
              _vm._s(_vm.errorCount) +
              " " +
              _vm._s(_vm.errorCount === 1 ? "issue" : "issues") +
              " found\n\t"
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { domProps: { innerHTML: _vm._s(_vm.sanitizedContent) } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }